// MIXINS FOR "MENU ITEMS SELECTION" PAGE
import {AjaxMixin} from '@mymyMixins/ajax';
import {CartMixin} from '@/js/funnel/_mixins/cart';
import {DeliveryDateMixin} from '@/js/funnel/_mixins/delivery-date';
import {SelectionFiltersMixin} from '@/js/funnel/_mixins/selection-filters';
import {GeneralMixin} from '@/js/funnel/_mixins/general';
import {GtmEcommerceHelperMixin, GtmEventsMenuItemsSelectionMixin, GtmEventsCheckoutMixin} from '@/js/funnel/_mixins/gtm';
import {InitMixin} from '@/js/funnel/_mixins/init';
import {MenuCookieMixin} from '@/js/funnel/_mixins/menu-cookie';
import {ModalsMixin} from '@/js/funnel/_mixins/modals';
import {MenuSectionsMixin} from '@/js/funnel/_mixins/menu-sections';
import {PaymentMethodsMixin} from '@/js/funnel/_mixins/payment-methods';
import {UrlsMixin} from '@/js/funnel/_mixins/urls';

/**
 * Mixins to be applied to a menu's "Items Selection" and checkout pages.
 *
 * @type {array}
 */
const MixinsForAllPages = [
   InitMixin,
   AjaxMixin,
   CartMixin,
   GeneralMixin,
   GtmEcommerceHelperMixin,
   MenuCookieMixin,
   ModalsMixin,
   MenuSectionsMixin,
   UrlsMixin,
];

/**
 * Full list of mixins for a menu's "Items Selection" page.
 *
 * @type {array}
 */
export const SelectionMixins = [
   DeliveryDateMixin,
   SelectionFiltersMixin,
   GtmEventsMenuItemsSelectionMixin,
].concat(MixinsForAllPages);

/**
 * Full list of mixins for the 1st checkout page: "Delivery Details".
 *
 * @type {array}
 */
export const DeliveryMixins = [
   DeliveryDateMixin,
   GtmEventsCheckoutMixin,
].concat(MixinsForAllPages);

/**
 * Full list of mixins for the 2nd checkout page: "Order Overview".
 *
 * @type {array}
 */
export const OverviewMixins = [
   PaymentMethodsMixin,
   GtmEventsCheckoutMixin,
].concat(MixinsForAllPages);